import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { AppService } from '../../../services/app.service';
import { Store } from '@ngrx/store';
import { appReducerState } from '../../../store/reducers/appReducer';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class ClientLoginComponent implements OnInit {
  public globalResponseError: string;

  constructor(
    private _authService: AuthService,
    private _appService: AppService,
    private _router: Router,
    private _store: Store<appReducerState>
  ) {}

  ngOnInit() {}

  onLoginUser(loginData: any) {
    this._authService.loginObservable(loginData.value, 'client').subscribe(
      (user) => {
        this._router.navigate(['/client/dashboard']);
      },
      (errorResponse) => {
        const errors: Array<string> = this._appService.getError(errorResponse);
        this.globalResponseError = errors['global'] || '';
        this._appService.setFormGroupErrors(loginData, errors);
        this._appService.showGlobalError(errors);
      }
    );
  }
}
